import React, { useState } from 'react'
import NextPrev from '../Util/NextPrev'
import { getDate, getAmount } from '../../Services/util-functions'
import Button from '../Design/Button'

const Bills = props => {
  const [billIndex, setBillIndex] = useState(0)
  const [transition, setTransition] = useState('')

  const bill = props.bills[billIndex]
  const length = props.bills.length

  return (
    <div id='account-overview-bills' className='account-overview-card fade-in'>
      <h2>Bills</h2>
      <div className='account-overview-card-content'>
        {
          length
            ? (
              <div>
                <div className={transition}>
                  <p>{bill.desc}</p>
                  <p>{getAmount(bill.amount)}</p>
                  <p>{getDate(bill.dueDate)}</p>
                </div>
                <NextPrev
                  setTransition={setTransition}
                  setIndex={setBillIndex}
                  index={billIndex}
                  length={length}
                />
              </div>
            )
            : <p>no bills added</p>
        }
        <Button addClass='edit-button' clicked={props.onHandleViewBills} text='Edit Bill' />
      </div>
    </div>
  )
}

export default Bills
